export default "__VITE_ASSET__gT6iEGpU__"